import { render, staticRenderFns } from "./SupplierObligations.vue?vue&type=template&id=6e60a83c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/hemmelig/components/contract/SupplierObligations.vue
// module id = null
// module chunks = 